<nav class="navbar navbar-light bg-light navbar-expand-lg mb-3" [formGroup]="busquedasCliente">
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav me-auto">
      <li class="nav-item me-2">
        <input id="clienteFormControl" type="text" class="form-control" formControlName="clienteFormControl"
          placeholder="Cliente/Cuenta" (input)="filtroClientes()" />
      </li>
      <!-- desde -->
      <li class="nav-item me-2">
        <div class="input-group">
          <input type="date" formControlName="fechaFormControlDesde" placeholder="aaaa-mm-dd" name="dt" ngbDatepicker
            #d="ngbDatepicker" class="form-control form-control-rounded" #searchDate required readonly>
          <div class="input-group-append">
            <button id="botonDesde" type="button" class="input-group-btn btn btn-secondary" (click)="d.toggle()">
              <i class="fa fa-calendar" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </li>
      <!-- hasta -->
      <li class="nav-item">
        <div class="input-group">
          <input type="date" formControlName="fechaFormControlHasta" placeholder="aaaa-mm-dd" name="dp"
            class="form-control form-control-rounded" ngbDatepicker #h="ngbDatepicker" #searchDate required readonly>

          <div class="input-group-append">
            <button id="botonHasta" type="button" class="input-group-btn btn btn-secondary" (click)="h.toggle()">
              <i class="fa fa-calendar" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </li>
      <li class="nav-item">
        <button (click)="buscarDesdeHasta()" [disabled]="fechasIncorrectas()"
          class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" type="submit">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </li>
      <!-- Solo vigentes -->
      <li class="nav-item ms-3 me-2">
        <div class="mt-2">
          <input type="checkbox" style="cursor: pointer;" class="form-check-input me-2" id="exampleCheckVigencia"
            formControlName="soloVigenteFormControl" (click)="filtroVigentes()" />
          <label class="form-check-label" for="exampleCheckVigencia">Solo vigentes</label>
        </div>
      </li>
      <!-- Aprobar factura -->
      <li class="nav-item ms-3">
        <button (click)="aprobarFactura()" class="btn btn-outline-primary" type="submit"
          [disabled]="!puedeAprobarFactura">
          Aprobar factura
        </button>
      </li>
    </ul>
    <ul class="navbar-nav">
      <!-- Imprimir -->
      <li class="nav-item ms-3">
        <button (click)="imprimir()" class="btn btn-outline-secondary" type="submit">
          <i class="fa fa-print" aria-hidden="true"></i>
          Imprimir
        </button>
      </li>
    </ul>
  </div>
</nav>
<div class="col-12 container-fluid">
  <div class="spinner-container" *ngIf="esperandoCarga">
    <ngx-spinner name="spinnerGrafico" [ngStyle]="{'height': '400px', 'z-index':'0'}" bdOpacity=0.3bd
      Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
      <p style="color: white">C a r g a n d o . . . </p>
    </ngx-spinner>
  </div>

  <ngb-alert class="alert alert-warning mt-2" *ngIf="clientesFiltrados.length == 0 && !esperandoCarga">
    No existen movimientos para la busqueda seleccionada.
  </ngb-alert>

  <!-- </form> -->
  <div *ngIf="!esperandoCarga && clientesFiltrados.length>0" id="scroll-infinito" infinite-scroll
    [infiniteScrollDistance]="distance" [infiniteScrollThrottle]="throttle" [scrollWindow]="false"
    [infiniteScrollDisabled]="this.obteniendoDatosScroll || !clientesRecibidos || clientesRecibidos.length === 0"
    (scrolled)="onScrollSaldos()">
    <div id="clientesPrint" *ngIf="clientesFiltrados.length > 0 && !esperandoCarga">
      <div *ngFor="let cli of clientesFiltrados">
        <h5 class="modal-title">Cliente: {{ cli.descripcion +" - "+ cli.ctA_SGC + " | Producto: " + cli.producto
          }}</h5>
        <table class="table table-striped table-hover" id="tablaInformacion" *ngIf="cli.movimientosSaldo?.length > 0">
          <thead class="titulo text-center">
            <tr>
              <th>Movimiento</th>
              <th>Aerovale</th>
              <th>Comprobante</th>
              <th>Fecha Comprobante</th>
              <th>Vigencia hasta</th>
              <th>Estado</th>
              <th>Responsable</th>
              <th>Precio utilizado</th>
              <th>Compra</th>
              <th>Dev/Cons</th>
              <th>Saldo</th>
              <th>Saldos Vencidos</th>
              <th class="no-print">Sel.</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody class="text-center ">
            <tr *ngFor="let item of cli.movimientosSaldo; let i=index"
              [ngClass]="{'negrita': item.tipoMovimiento === TipoMovimientoFacturacion.SaldoAnterior }">
              <td>{{ obtenerTipoMovimiento(item.tipoMovimiento) }}</td>
              <td>
                @if (item.tipoMovimiento !== TipoMovimientoFacturacion.SaldoAnterior) {
                {{ item.prefijoNumeroAerovale }}
                @if (item.tipoMovimiento !== TipoMovimientoFacturacion.Devolucion) {
                <button class="btn" ngbTooltip="Ver aerovale">
                  <i *ngIf="!obteniendoAerovale || obteniendoAerovale && aerovaleSeleccionado!=i" class="fa fa-eye"
                    aria-hidden="true" (click)="obtenerAerovale(item.aerovaleId, i)"></i>
                  <div *ngIf="aerovaleSeleccionado==i && obteniendoAerovale">
                    <div class="spinner-border text-primary spinner-border-sm" role="status"></div>
                    <span><i class="fa fa-eye" aria-hidden="true"></i></span>
                  </div>
                </button>
                }
                } @else {
                {{ "" }}
                }
              </td>
              <td>
                @if (item.tipoMovimiento === TipoMovimientoFacturacion.Recarga && item.estadoSaldoRecarga !==
                EstadoFacturaAnticipadaRecarga.Pendiente) {
                {{ item.numeroComprobante }}
                <button class="btn" ngbTooltip="Ver factura">
                  <i *ngIf="!obteniendoComprobante || obteniendoComprobante && comprobanteSeleccionado!=i"
                    class="fa fa-eye" aria-hidden="true" (click)="obtenerFactura(item.comprobanteId, i)"></i>
                  <div *ngIf="comprobanteSeleccionado==i && obteniendoComprobante">
                    <div class="spinner-border text-primary spinner-border-sm" role="status"></div>
                    <span><i class="fa fa-eye" aria-hidden="true"></i></span>
                  </div>
                </button>
                } @else {
                {{ "" }}
                }
              </td>
              <td>
              @if(item.tipoMovimiento !== TipoMovimientoFacturacion.SaldoAnterior && item.tipoMovimiento !== TipoMovimientoFacturacion.Consumo) {
                {{ item.fechaHoraComprobante | date: "dd'/'MM'/'y' 'hh:mm a" }}
              } @else if(item.tipoMovimiento == TipoMovimientoFacturacion.Consumo) {
                {{ item.fechaHora | date: "dd'/'MM'/'y' 'hh:mm a" }}
              }
              </td>
              <td>{{ item.tipoMovimiento !== TipoMovimientoFacturacion.SaldoAnterior ? (item.fechaHoraVigenciaHasta |
                date: "dd'/'MM'/'y' 'hh:mm a") : "" }}</td>
              @if(!item.anulado) {
                <td>{{ item.tipoMovimiento === TipoMovimientoFacturacion.Recarga ?
                  obtenerEstadoRecarga(item.estadoSaldoRecarga) : (item.tipoMovimiento ===
                  TipoMovimientoFacturacion.Devolucion) ? obtenerEstado(item.estadoSaldoDevolucion) : "" }}</td>
              }@else {
                <td>Anulado</td>
              }
              <td>{{ (item.estadoSaldoRecarga == EstadoFacturaAnticipadaRecarga.Disponible) ? item.responsable : "" }}
              </td>
              <td> @if(item.tipoMovimiento !== TipoMovimientoFacturacion.SaldoAnterior && item.tipoMovimiento !==
                TipoMovimientoFacturacion.Consumo) {
                  {{ getTipoMoneda(item.tipoMoneda) }}{{ item.precioUtilizado | number:"1.0-0" }} }</td>
              <td>{{ item.tipoMovimiento === TipoMovimientoFacturacion.Recarga ? (item.cantidadLitros | number:"1.0-0")
                : "" }}</td>
              <td>{{ (item.tipoMovimiento === TipoMovimientoFacturacion.Consumo || item.tipoMovimiento ===
                TipoMovimientoFacturacion.Devolucion) ? (item.cantidadLitros | number:"1.0-0") : "" }}</td>
              <!-- devolucion o pedido-->
              <td>{{ item.saldo | number:"1.0-0"}}</td>
              <td style="color: red">
                @if (item.tipoMovimiento === TipoMovimientoFacturacion.SaldoAnterior){
                  {{ item.saldoAnteriorVencido ?? 0 | number:"1.0-0"}}
                } @else if (item.tipoMovimiento === TipoMovimientoFacturacion.Recarga){
                  {{ item.saldoVencido ?? 0 | number:"1.0-0"}}
                }
              </td>
              <td class="no-print"> @if (item.tipoMovimiento === TipoMovimientoFacturacion.Recarga) {
                <input type="checkbox" style="cursor: pointer;" class="mt-2"
                  [disabled]="item.estadoSaldoRecarga !== EstadoFacturaAnticipadaRecarga.Facturado"
                  (change)="campoSeleccionado($event, item.estadoSaldoRecarga, item.aerovaleId)">
                }
              </td>
              <td><button *ngIf="item.estadoSaldoRecarga == EstadoFacturaAnticipadaRecarga.Pendiente && !item.anulado"
                  (click)="anularAerovalePendiente(item.aerovaleId, i)" class="btn btn-sm btn-danger">
                  @if(anulandoAerovale !== i) {Anular} @else { <div class="spinner-border spinner-border-sm"
                    role="status"></div><span>Cargando...</span> }</button>
              </td>
            </tr>
            <tr class="resaltado">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Saldo Actual</td>
              <td>{{ cli.saldoActual | number: '1.0-0' }}</td>
              <td style="color: red">{{ cli.saldoVencidoTotal | number: '1.0-0' }}</td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div style="justify-content: center;" *ngIf="this.obteniendoDatosScroll"
      class="d-flex align-items-center text-primary">
      <div class="spinner-border" role="status"></div><span>Cargando mas datos..</span>
    </div>
  </div>
</div>
